import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { track } from 'utils/analytics';

// import Product from './Product';
import PersonasContainer from './PersonasContainer';

import { restart } from 'actions';
import { tally } from 'utils/array';
import getQueryParameterByName from 'utils/getQueryParameterByName';

import './index.css';

class Results extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentPersona: 0,
			transition: null,
			height: 'auto'
		};

		this.sorted = [];
		this.getNextPersona = this.getNextPersona.bind(this);
		this.handleRestartClick = this.handleRestartClick.bind(this);
		this.updateHeight = this.updateHeight.bind(this);
	}

	handleRestartClick() {
		// restart quiz
		const { dispatch } = this.props;
		dispatch(restart(0));

		track('clicked', 'restart quiz');
	}

	updateHeight(height) {
		console.log('::::::::::::::::::: height', height);
		this.setState(() => ({ height }));
	}

	getNextPersona() {
		const { archetypes } = this.props;
		const { currentPersona } = this.state;
		const nextPersona = (currentPersona < archetypes.length - 1) ? currentPersona + 1 : 0;
		track('visible', `Result ${this.sorted[nextPersona].personaName}`);
		this.setState(() => ({
			currentPersona: nextPersona
		}));
	}

	componentDidMount() {
		const { view: { id }, archetypes } = this.props;
		const { currentPersona } = this.state;
		track('visible', `Result ${this.sorted[currentPersona].personaName}`);

		if (id === 'results') {
			setTimeout(() => {
				this.setState(() => ({
					transition: 'in'
				}));
			}, 10);
		}
	}

	render() {
		const { view, quiz, archetypes, personas, base: { imageCredits } } = this.props;
		const { currentPersona, transition, height } = this.state;
		const personaIdOverride = getQueryParameterByName('persona');
		const personaId = personaIdOverride ? +personaIdOverride : tally(quiz.answers) || 1;
		let bgColour = null, currentPersonaColour = null;
		this.sorted = [];
		console.log('render');
	
    if (archetypes) {
      archetypes.forEach(archetype => {
        if (+archetype.personaNumber !== +personaId) {
					this.sorted.push(archetype);
        } else {
					this.sorted.unshift(archetype);
        }
      });
		}

		bgColour = 'white';//quiz.themes[themeIndex].backgroundHexColor;

		if (!archetypes) return <div className='results view'></div>;

		return (
			<Fragment>
				<div className={`results view ${view.id === 'results' ? 'active' : ''} ${transition}`} style={{ /*height,*/ backgroundImage: `url(./bgs/result.desktop.jpg)` }}
					ref={instance => this.results = instance}>
					<div className="inner">
						<div className="result">
							<div className="mobile-background" />
							<div className="other-trends" onClick={this.getNextPersona}>
								<img className="arrow" src="./arrow.png" alt="arrow" />
								See Other Trends
							</div>
							<div className="persona-container">
								<PersonasContainer sorted={this.sorted} personas={personas} currentPersona={currentPersona} imageCredits={imageCredits} onRestartClick={this.handleRestartClick} updateHeight={this.updateHeight} />
							</div>
							{/* <div className={`lower-content persona-${currentPersonaColour}`}>
								<div className="restart" onClick={this.handleRestartClick}>Start Over</div>
								<div className="info">{imageCredits}</div>
							</div> */}
						</div>
					</div>
				</div>
				<div className={`footer ${view.id === 'results' ? 'active' : ''}`}>
					<img className="logo" src="./logo.svg" alt="ref29-logo" />
					<p className="legal">© 2018 REFINERY29 INC.<br />BY USING OUR SERVICE, YOU AGREE TO OUR TERMS (EFFECTIVE 2/07/2017) AND PRIVACY (EFFECTIVE 8/23/2016).<br />REFINERY29 NAME & LOGO AND R29 LOGO ARE TRADEMARKS OF REFINERY 29 INC.</p>
				</div>
			</Fragment>
		)
	}
}

const mapStateToProps = state => {
  return {
		view: state.view,
		quiz: state.quiz
  }
}

Results = connect(mapStateToProps)(Results);
export default Results;



// WEBPACK FOOTER //
// ./src/components/Results/index.js